import {
  ArcElement,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  Tooltip,
} from 'chart.js';
import { mergeWith } from 'lodash-es';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { ChartContainer, ChartContainerProps } from './ChartContainer';
import { defaultPluginsOption } from './constants';

ChartJS.register(ArcElement, Tooltip, Legend);

const baseOptions: ChartOptions<'doughnut'> = {
  plugins: defaultPluginsOption,
};

type DoughnutChartProps = Omit<
  React.ComponentProps<typeof Doughnut>,
  'title'
> & {
  containerRef?: React.ForwardedRef<HTMLDivElement>;
} & Pick<ChartContainerProps, 'title'>;

export const DoughnutChart = ({
  title,
  options,
  containerRef,
  ...props
}: DoughnutChartProps) => {
  return (
    <ChartContainer title={title} ref={containerRef}>
      <Doughnut {...props} options={mergeWith(baseOptions, options)} />
    </ChartContainer>
  );
};
